// import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { Observable } from 'rxjs';
import { has, isNil, isObject, isString, find, isEmpty,  } from 'lodash';

import { DataSource, ServerDataSource } from 'angular2-smart-table';
import { Model } from './common/.base.model';
import { EntityConfigTemplate } from './common/entity-config.interface';
import { FormConfigTemplate } from './common/form-config-template.interface';

export interface InternalDoc extends Model {
  title: string;
  description?: string;
  file?: any;
  // uploadedAt?: Date | string;
  aiStatus?: boolean;
}

export const InternalDocConfig: EntityConfigTemplate = {
  meta: { entityName: 'internal-doc', entityPluralName: 'internal-docs', titleField: 'title', view: false },
  title: { title: 'Title' },
  description: { title: 'Description' },
  file: { title: 'File', type: 'file', view: { list: false } },
  // uploadedAt: { title: 'Uploaded At', type: 'date' },
  // isProcessed: { title: 'Is Processed', type: 'select' },
  aiStatus: { title: 'Processing Status', type: 'text' },
};


const processedStatus = [
  { value: true, label: 'Yes'},
  { value: false, label: 'No'},
];

export const InternalDocFormConfig: FormConfigTemplate = {
  tabs: [
    {
      title: "File Details",
      columns: [
        {
          size: "col-12",
          type: "form",
          sections: [
            {
              rows: [
                {
                  fields: [
                    { name: "title", label: "Title", type: "text", required: true, size: "col-6" },
                    // { name: "uploadedAt", label: "Uploaded At", type: "date", size: "col-6" },
                  ]
                },
                {
                  fields: [
                    { name: "file", label: "File", type: "file", size: "col-6" },
                    { name: "aiStatus", label: "Processing Status", type: "text", options: processedStatus, size: "col-6" },
                  ]
                },
                {
                  fields: [
                    { name: "description", label: "Description", type: "textarea", required: false, size: "col-12" },
                  ] 
                }
              ],
            }
          ],
        },
      ],
    },
  ],
};

export abstract class InternalDocData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<InternalDoc[]>;
  abstract listAll(): Observable<InternalDoc[]>;
  abstract get(id: string): Observable<InternalDoc>;
  abstract update(InternalDoc: InternalDoc): Observable<InternalDoc>;
  abstract create(InternalDoc: InternalDoc): Observable<InternalDoc>;
  abstract delete(id: string): Observable<boolean>;
  abstract chat(message): Observable<string>;
}




